/**
 * useSlashCommands — Chat slash command parser
 * /askai, /research, /social, /ticket, /skill, /todo, /code, /note, /event, /web, /find, /task, /analyze, /help
 */

export interface SlashCommand {
  command: string
  args: string
}

export const SLASH_COMMANDS = [
  { cmd: '/askai',    desc: 'Ask AI — quick answer', example: '/askai What is React?' },
  { cmd: '/brief',    desc: 'Plan project — auto-split into tasks', example: '/brief Build a login system' },
  { cmd: '/brain',    desc: 'Add to Brain Wiki', example: '/brain React Hooks React hooks allow...' },
  { cmd: '/complexity', desc: 'Analyze task complexity', example: '/complexity' },
  { cmd: '/expand',   desc: 'Generate subtasks for task', example: '/expand 123' },
  { cmd: '/next',     desc: 'Get next recommended task', example: '/next' },
  { cmd: '/research', desc: 'Start research', example: '/research quantum computing' },
  { cmd: '/social',   desc: 'Post to social feed', example: '/social Great day today!' },
  { cmd: '/ticket',   desc: 'Create support ticket', example: '/ticket Login issue' },
  { cmd: '/skill',    desc: 'Run a skill', example: '/skill run web-scraper' },
  { cmd: '/todo',     desc: 'Quick add task', example: '/todo Finish report' },
  { cmd: '/imagine',  desc: 'Generate image', example: '/imagine a futuristic city' },
  { cmd: '/translate', desc: 'Translate text', example: '/translate Hello to Turkish' },
  { cmd: '/code',     desc: 'Open code editor', example: '/code explain this function' },
  { cmd: '/note',     desc: 'Open markdown editor', example: '/note My thoughts' },
  { cmd: '/event',    desc: 'Create calendar event', example: '/event 2026-05-15 Team meeting' },
  { cmd: '/web',      desc: 'Open browser', example: '/web github.com' },
  { cmd: '/wiki',     desc: 'Search Brain Wiki', example: '/wiki React hooks' },
  { cmd: '/find',     desc: 'Search files', example: '/find project.tsx' },
  { cmd: '/task',     desc: 'Create new task', example: '/task Write documentation' },
  { cmd: '/analyze',  desc: 'Analyze current window', example: '/analyze' },
  { cmd: '/help',     desc: 'Command list', example: '/help' },
]

export function parseSlashCommand(input: string): SlashCommand | null {
  const trimmed = input.trim()
  if (!trimmed.startsWith('/')) return null

  const spaceIdx = trimmed.indexOf(' ')
  const command = spaceIdx > 0 ? trimmed.slice(0, spaceIdx).toLowerCase() : trimmed.toLowerCase()
  const args = spaceIdx > 0 ? trimmed.slice(spaceIdx + 1).trim() : ''

  const valid = SLASH_COMMANDS.find(c => c.cmd === command)
  if (!valid) return null

  return { command, args }
}

export function getHelpText(): string {
  return SLASH_COMMANDS.map(c => `${c.cmd} — ${c.desc}\n  Örnek: ${c.example}`).join('\n\n')
}
